'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('whatwg-fetch');

var _immutable = require('immutable');

var _RenderQuiz = require('./RenderQuiz');

var _RenderQuiz2 = _interopRequireDefault(_RenderQuiz);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Render = function (_Component) {
  _inherits(Render, _Component);

  function Render() {
    _classCallCheck(this, Render);

    return _possibleConstructorReturn(this, (Render.__proto__ || Object.getPrototypeOf(Render)).apply(this, arguments));
  }

  _createClass(Render, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var quizData = this.props.quizData;


      this.setState({
        status: 'loading',
        fontStatus: 'loading',
        data: null
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.state.status === 'loading' && this.props.quizData) {
        this.setState({
          status: 'success',
          data: _immutable.Map.isMap(this.props.quizData) ? this.props.quizData : (0, _immutable.fromJS)(this.props.quizData)
        });
      }
      if (this.props.quizId) {
        var quizUrl = this.props.apiUrl + '/quizzes/' + this.props.quizId;
        if (this.props.countryCode) {
          quizUrl = this.props.apiUrl + '/quizzes/by-country/' + this.props.countryCode + '/' + this.props.quizId;
        }
        fetch(quizUrl).then(function (res) {
          if (!res.ok) {
            throw new Error('Non 200 response for quiz fetch');
          }
          return res.json();
        }).then(function (body) {
          _this2.setState({
            status: 'success',
            data: (0, _immutable.fromJS)(body)
          });
        }).catch(function (error) {
          if (_this2.state && _this2.state.status && _this2.state.status === 'success') {
            console.error('Ignoring because we already have a successful state: Fetch quiz error', error);
          } else {
            console.error('Fetch quiz error', error);
            _this2.setState({
              status: 'failed'
            });
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.status === 'loading') {
        return _react2.default.createElement(
          'div',
          { className: 'loading' },
          'Loading...'
        );
      }
      var formArgs = {};
      if (!!this.props.formArgs) {
        formArgs = this.props.formArgs;

        formArgs = Object.keys(formArgs).reduce(function (c, k) {
          return c[k.toLowerCase()] = formArgs[k], c;
        }, {});
      }

      if (this.state.status === 'success') {
        return _react2.default.createElement(_RenderQuiz2.default, { quizId: this.props.quizId, formArgs: formArgs, quizData: this.state.data, apiUrl: this.props.apiUrl, onTracking: this.props.onTracking });
      }
      return _react2.default.createElement(
        'div',
        { className: 'error' },
        'Sorry an error occurred. ',
        _react2.default.createElement(
          'pre',
          { style: { 'display': 'none' } },
          JSON.stringify(this.state, true, 2)
        )
      );
    }
  }]);

  return Render;
}(_react.Component);

exports.default = Render;
;


//////////////////
// WEBPACK FOOTER
// ./node_modules/wse-quiz-component/lib/Render.js
// module id = 695
// module chunks = 0